import {Bootstrap} from '../Includes/Bootstrap';

class Default extends Bootstrap {
}

new Default();
